import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  addButton: {
    marginRight: theme.spacing(-1),
    whiteSpace: 'nowrap',
  },
  deleteButton: {
    color: theme.palette.error.main,
    '&:hover': {
      backgroundColor: theme.palette.error.light + '22',
    },
  },
  tableRow: {
    height: 56,
  },
  tableCell: {
    fontSize: theme.typography.body1.fontSize,
  },
}))

export default useStyles
